<template>
    <PopupRouterViewDetail label="Stock Opname Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Stock Opname" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="6" lg="6">
					<app-input-combobox-autocomplete :options="stockOpnamePlans" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Opname Plan" id="fieldset-stock-opname-plan" size="sm" :model.sync="model.stockOpnamePlanId"   :selected="model.stockOpnamePlan != null ? model.stockOpnamePlan.name : ''" @input="getStockOpnamePlans" @change="updateData" :isUpdatable ="false" :isEditable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpnamePlan" />
					<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area-sto" size="sm" :model.sync="model.areaStoId"   :selected="model.areaSto != null ? model.areaSto.code : ''" @input="getAreas" @change="updateData" :isUpdatable ="false" :isEditable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedAreaSto" />
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Subcontract Vendor" id="fieldset-vendor-subcon" size="sm" :model.sync="model.vendorSubconId"   :selected="model.vendorSubcon != null ? model.vendorSubcon.code : ''" @input="getVendors" @change="updateData" :isUpdatable ="false" :isEditable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedVendorSubcon" />
					<app-input-textbox id="fieldset-id-card" label-cols-lg="12"  label="ID Card" label-for="input-id-card" size="sm" :model.sync="model.idCard"  @change="updateData" :isUpdatable ="false" :isEditable ="false"/>
				</b-col>
				<b-col cols="6" lg="6">
					<app-input-textbox id="fieldset-total-case-area" label-cols-lg="12"  label="Total Case" label-for="input-total-case-area" size="sm" type="number" :model.sync="model.totalCaseArea"  @change="updateData" :isUpdatable ="false" :isEditable ="false"/>
					<app-input-textbox id="fieldset-total-case-actual" label-cols-lg="12"  label="Total Case Actual" label-for="input-total-case-actual" size="sm" type="number" :model.sync="model.totalCaseActual"  @change="updateData" :isUpdatable ="false" :isEditable ="false"/>
					<app-input-combobox-autocomplete :options="stockOpnameStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Opname Status" id="fieldset-stock-opname-status" size="sm" :model.sync="model.stockOpnameStatusId"   :selected="model.stockOpnameStatus != null ? model.stockOpnameStatus.name : ''" @input="getStockOpnameStatuss" @change="updateData" :isUpdatable ="false" :isEditable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockOpnameStatus" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Stock Opname Case" :bordered="true" :items="stockOpnameDetails" :fields="fieldsStockOpnameDetail" :busy="isDataLoading" :sort-by.sync="sortByStockOpnameDetail" :sort-desc.sync="sortDescStockOpnameDetail" small responsive
			@editButtonMethod="editRowDataStockOpnameDetail"
			@deleteButtonMethod="deleteRowDataStockOpnameDetail"
			@showPopupAddMethod="resetDataStockOpnameDetail()"
			@showPopupUploadMethod="showPopupUploadStockOpnameDetail()"
			@downloadMethod="downloadStockOpnameDetail()"
			@addFromClipboardMethod="addFromClipboardStockOpnameDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardStockOpnameDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadStockOpnameDetail"
			>
			<template #top-row v-if="isShowStockOpnameDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Case Number">
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'filter-stock-opname-detail-card'" label-cols-lg="12" label="Control Card" size="sm" :model.sync="filterStockOpnameDetail.controlCardId"  @change="getStockOpnameDetails" @input="getControlCards" :loading="isControlCardComboLoading" :nolabel="true" />
					<!-- <v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterStockOpnameDetail.controlCardId" :reduce="item => item.id" v-model="filterStockOpnameDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select> -->
				</b-th>
				<b-th stacked-heading="Part">
					<!-- <v-select append-to-body label="partNumber" :options="parts"  :value="filterStockOpnameDetail.partId" :reduce="item => item.id" v-model="filterStockOpnameDetail.partId" @search="getParts" :filterable="true"></v-select> -->
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'filter-stock-opname-detail-part'" label-cols-lg="12" label="Part" size="sm" :model.sync="filterStockOpnameDetail.partId"  @change="getStockOpnameDetails" @input="getParts" :loading="isPartComboLoading" :nolabel="true" />
				</b-th>
				<b-th></b-th>
				<b-th stacked-heading="Qty System">
					<!-- <b-form-input id="input-case-qty-table" v-model="filterStockOpnameDetail.caseQty" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Qty Actual">
					<!-- <b-form-input id="input-qty-actual-table" v-model="filterStockOpnameDetail.qtyActual" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Remarks">
					<!-- <b-form-input id="input-remarks-table" v-model="filterStockOpnameDetail.remarks" size="sm"></b-form-input> -->
				</b-th>
				<b-th stacked-heading="Scanned By">
					<!-- <app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="id" :id="'filter-stock-opname-detail-user'" label-cols-lg="12" label="User" size="sm" :model.sync="filterStockOpnameDetail.scannedById"  @change="getStockOpnameDetails" @input="getUserInfos" :loading="isUserInfoComboLoading" :nolabel="true" /> -->
					<!-- <v-select append-to-body label="firstName" :options="userInfos"  :value="filterStockOpnameDetail.scannedById" :reduce="item => item.id" v-model="filterStockOpnameDetail.scannedById" @search="getUserInfos" :filterable="true"></v-select> -->
				</b-th>
				<!-- <b-th stacked-heading="ID Card">
					<b-form-input id="input-user-id-card-table" v-model="filterStockOpnameDetail.userIdCard" size="sm"></b-form-input>
				</b-th> -->

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( stockOpnameDetailPageSize * (currentStockOpnameDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>

			<template v-slot:head(frontActions)>
				<b-button @click="isShowStockOpnameDetailFilter = !isShowStockOpnameDetailFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-stock-opname-detail-control-card-' + row.index" label-cols-lg="12" label="Case Number" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputStockOpnameDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(partLabel)="row">
				<app-label label-cols-lg="12" size="sm" label="Part" :model="(row.item.controlCard != null) ? (row.item.controlCard.part != null) ? row.item.controlCard.part.partNumber : null : null"  />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partName" optionsKey="id" :id="'input-stock-opname-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputStockOpnameDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(caseQty)="row">
				<app-input-textbox :id="'input-stock-opname-detail-case-qty-' + row.index" label-cols-lg="12" label="Qty System" size="sm" :model.sync="row.item.caseQty"   @change="saveInputStockOpnameDetail(row.item)" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(qtyActual)="row">
				<app-input-textbox :id="'input-stock-opname-detail-qty-actual-' + row.index" label-cols-lg="12" label="Qty Actual" size="sm" :model.sync="row.item.qtyActual"   @change="saveInputStockOpnameDetail(row.item)" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(remarks)="row">
				<app-input-textarea :id="'input-stock-opname-detail-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputStockOpnameDetail(row.item)" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(scannedBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-stock-opname-detail-scanned-by-' + row.index" label-cols-lg="12" label="Scanned By" size="sm" :model.sync="row.item.scannedById"  @change="saveInputStockOpnameDetail(row.item)" :selected="row.item.scannedBy != null ? row.item.scannedBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(userIdCard)="row">
				<app-input-textbox :id="'input-stock-opname-detail-user-id-card-' + row.index" label-cols-lg="12" label="ID Card" size="sm" :model.sync="row.item.userIdCard"   @change="saveInputStockOpnameDetail(row.item)" :isEditable="false"  :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<StockOpnameDetailInput 
					:openPopup="isShowPopupStockOpnameDetail"
					:modelId="stockOpnameDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataStockOpnameDetail"/>
			</template>
			<template v-slot:upload-detail>
				<StockOpnameDetailUpload
					:openPopup="isShowPopupUploadStockOpnameDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataStockOpnameDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
							<app-label label-cols-lg="12" size="sm" label="Part" :model="(row.item.controlCard != null) ? (row.item.controlCard.part != null) ? row.item.controlCard.part.partNumber : null : null"  />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-stock-opname-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputStockOpnameDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-detail-case-qty-' + row.index" label-cols-lg="12" label="Qty System" size="sm" :model.sync="row.item.caseQty"   @change="saveInputStockOpnameDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-stock-opname-detail-qty-actual-' + row.index" label-cols-lg="12" label="Qty Actual" size="sm" :model.sync="row.item.qtyActual"   @change="saveInputStockOpnameDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textarea :id="'input-stock-opname-detail-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputStockOpnameDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-stock-opname-detail-scanned-by-' + row.index" label-cols-lg="12" label="Scanned By" size="sm" :model.sync="row.item.scannedById"  @change="saveInputStockOpnameDetail(row.item)" :selected="row.item.scannedBy != null ? row.item.scannedBy.fullName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<!-- <app-input-textbox :id="'input-stock-opname-detail-user-id-card-' + row.index" label-cols-lg="12" label="ID Card" size="sm" :model.sync="row.item.userIdCard"   @change="saveInputStockOpnameDetail(row.item)" :isUpdatable="false" :isEditable="false"  /> -->
				</b-card>
			</template>

			<template #table-paging>
				<b-row>
					<b-col cols="12" class="paging-container">
						<div>
							<b-row>
								<b-col cols="12" class="paging-item">
									<b-pagination class="btn-paging paging-page-size float-right"
										v-model="currentStockOpnameDetailPage"
										:total-rows="(stockOpnameDetailsPaging != null ? stockOpnameDetailsPaging.dataCount : 0)"
										:per-page="(stockOpnameDetailsPaging != null ? stockOpnameDetailsPaging.pageSize : 0)"
										aria-controls="table-input">
										<template #first-text>
											<b-icon-chevron-left />
										</template>
										<template #prev-text>
											Prev
										</template>
										<template #next-text>
											Next
										</template>
										<template #last-text>
											<b-icon-chevron-right />
										</template>
									</b-pagination>
									<span class="paging-page-size float-right">
										<b-form-select v-if="false" v-model="stockOpnameDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										<b-dropdown :text="stockOpnameDetailPageSize + ' per page'" class="m-md-2 btn-paging-size" size="sm">
											<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="stockOpnameDetailPageSize = item.value">
												{{ item.text }}
											</b-dropdown-item>
										</b-dropdown>
									</span>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import StockOpname from '@/models/StockOpname/StockOpname';
import StockOpnameList from '@/models/StockOpname/StockOpnameList';
import StockOpnameFilter from '@/filters/StockOpname/StockOpnameFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockOpnamePlan from '@/models/StockOpnamePlan/StockOpnamePlan';
import StockOpnamePlanFilter from '@/filters/StockOpnamePlan/StockOpnamePlanFilter';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import StockOpnameStatus from '@/models/StockOpnameStatus/StockOpnameStatus';
import StockOpnameStatusFilter from '@/filters/StockOpnameStatus/StockOpnameStatusFilter';
import StockOpnameDetail from '@/models/StockOpname/StockOpnameDetail';
import StockOpnameDetailFilter from '@/filters/StockOpname/StockOpnameDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppLabel from '@/components/AppLabel';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import StockOpnameDetailInput from '@/views/StockOpname/StockOpnameDetailInput';
import StockOpnameDetailUpload from '@/views/StockOpname/StockOpnameDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppLabel,
		AppInputTextarea,
		StockOpnameDetailInput,StockOpnameDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsStockOpnameDetail: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Case Number", key: 'controlCard', sortable: false}}, 
				{"partLabel": { "class" : "th-part-label", "label" : "Part", key: 'partLabel', sortable: false}}, 
				{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part', sortable: false}}, 
				{"caseQty": { "class" : "th-case-qty d-stack-none", "label" : "Qty System", key: 'caseQty', sortable: false}}, 
				{"qtyActual": { "class" : "th-qty-actual d-stack-none", "label" : "Qty Actual", key: 'qtyActual', sortable: false}}, 
				{"remarks": { "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: false}}, 
				{"scannedBy": { "class" : "th-scanned-by d-stack-none", "label" : "Scanned By", key: 'scannedBy', sortable: false}}, 
				// {"userIdCard": { "class" : "th-user-id-card d-stack-none", "label" : "ID Card", key: 'userIdCard', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelStockOpnameDetail : {},
			isShowPopupStockOpnameDetail : false,
			isShowPopupUploadStockOpnameDetail : false,
			filterStockOpname : null,
			currentStockOpnamePage : 1,
			stockOpnamePageSize: 10,
			sortByStockOpname: '',
			sortDescStockOpname: '',
			filterStockOpnameDetail : null,
			currentStockOpnameDetailPage : 1,
			stockOpnameDetailPageSize: 10,
			sortByStockOpnameDetail: '',
			sortDescStockOpnameDetail: '',
			sortingByStockOpnameDetail: [],
			stockOpnameDetails : [],
			stockOpnameDetailId : '',
			totalStockOpnameDetailRow : 0,
			isShowStockOpnameDetailFilter: false,
			isDownloadStockOpnameDetail: false,
			controlCards: [],
			parts: [],
			userInfos: [],
			stockOpnamePlans: [],
			stockOpnamePlans: [],
			isStockOpnamePlanComboLoading: false,
			areas: [],
			areaStos: [],
			isAreaStoComboLoading: false,
			vendors: [],
			vendorSubcons: [],
			isVendorSubconComboLoading: false,
			stockOpnameStatuss: [],
			stockOpnameStatuss: [],
			isStockOpnameStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isStockOpnamePlanComboLoading: false,
			isAreaComboLoading: false,
			isVendorComboLoading: false,
			isStockOpnameStatusComboLoading: false,
			isStockOpnameComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isUserInfoComboLoading: false,
			stockOpnameDetailsPaging: {},
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getStockOpname : async function(id) {
			this.isBusy = true;
			StockOpname.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadStockOpname = true;
			this.filterStockOpname.id = this.modelId;
			StockOpname.downloadDataDetail(this, this.filterStockOpname).then(result => {
				this.isDownloadStockOpname = false;
			}).catch(error => { this.isDownloadStockOpname = false; })
		},
		getStockOpnameDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterStockOpnameDetail);
			if (this.modelId == null) return;
			filter.stockOpnameId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByStockOpnameDetail != null) {
				this.sortingByStockOpnameDetail[this.sortByStockOpnameDetail] = this.sortDescStockOpnameDetail;
			}
			let currentPage = (this.currentStockOpnameDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalStockOpnameDetailRow + 1;
				let page = Math.ceil(totalData/this.stockOpnameDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			//currentPage = null;
			//this.stockOpnameDetailPageSize = 0;
			// disable paging end
			StockOpnameDetail.getList(this, filter, this.sortingByStockOpnameDetail, currentPage , this.stockOpnameDetailPageSize).then(result => {
				this.currentStockOpnameDetailPage = currentPage + 1;
				this.stockOpnameDetails = result.data;
				this.totalStockOpnameDetailRow = result.dataCount;
				this.stockOpnameDetailsPaging = result;
			}).catch(error => {});
		},
		getStockOpnames : async function(input) {
			let filter = new StockOpnameFilter();
			if (input != undefined) {
				filter.StockOpnamePlan = input;
			}
			this.isStockOpnameComboLoading = true;
			StockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
				}
				this.isStockOpnameComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnames : async function(input) {
			let filter = new StockOpnameFilter();
			if (input != undefined) {
				filter.stockOpnamePlan = input;
			}
			this.isStockOpnameComboLoading = true;
			StockOpname.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnames = result.data
				}
				this.isStockOpnameComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getStockOpnamePlans : async function(input) {
			let filter = new StockOpnamePlanFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockOpnamePlan.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnamePlans = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnamePlan(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnamePlanId = null;
				this.model.stockOpnamePlan = null;
			} else {
				this.model.stockOpnamePlanId = item.id;
				this.model.stockOpnamePlan = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedAreaSto(item) {
			if(item == undefined || item == null) {
				this.model.areaStoId = null;
				this.model.areaSto = null;
			} else {
				this.model.areaStoId = item.id;
				this.model.areaSto = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getVendors : async function(input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Vendor.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.vendors = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedVendorSubcon(item) {
			if(item == undefined || item == null) {
				this.model.vendorSubconId = null;
				this.model.vendorSubcon = null;
			} else {
				this.model.vendorSubconId = item.id;
				this.model.vendorSubcon = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getStockOpnameStatuss : async function(input) {
			let filter = new StockOpnameStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockOpnameStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockOpnameStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockOpnameStatus(item) {
			if(item == undefined || item == null) {
				this.model.stockOpnameStatusId = null;
				this.model.stockOpnameStatus = null;
			} else {
				this.model.stockOpnameStatusId = item.id;
				this.model.stockOpnameStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.stockOpnameInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					StockOpname.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockopnameindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					StockOpname.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'stockopnameindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockOpname.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getStockOpname(id);
					});
				}
			});
		},
		onHidden() {
			this.getStockOpnames();
		},
		addRowDataStockOpnameDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.stockOpnameId =  this.modelId;
					StockOpnameDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getStockOpnameDetails(true);
						this.isShowPopupStockOpnameDetail = false;
					})
				} else {
					model.stockOpnameId =  this.modelId;
					StockOpnameDetail.createDataDetail(this, model)
					.then(result => {
						this.getStockOpnameDetails(true);
						this.isShowPopupStockOpnameDetail = false;
					})
				}
			}
		},
		async editRowDataStockOpnameDetail(id) {
			this.stockOpnameDetailId = id;
			this.isShowPopupStockOpnameDetail = true; 
		},
		async deleteRowDataStockOpnameDetail(id) {
			StockOpnameDetail.deleteData(this, id).then(result => { this.getStockOpnameDetails(); });
		},
		async resetDataStockOpnameDetail() {
			this.stockOpnameDetailId = "";
			this.isShowPopupStockOpnameDetail = true;
		},
		async addDataStockOpnameDetail() {
			StockOpnameDetail.createData(this, { stockOpnameId: this.modelId })
			.then(result => {
				this.getStockOpnameDetails(true);
			})
		},
		async addFromClipboardStockOpnameDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockOpnameId: this.modelId });
				});
				StockOpnameDetail.addFromClipboard(this, controlCards).then(result => { this.getStockOpnameDetails() });
			});
		},
		async replaceFromClipboardStockOpnameDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockOpnameId: this.modelId });
				});
				StockOpnameDetail.replaceFromClipboard(this, controlCards).then(result => { this.getStockOpnameDetails() });
			});   
		},
		showPopupUploadStockOpnameDetail() {
			if(this.stockOpnameDetails != null && this.stockOpnameDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap StockOpnameDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadStockOpnameDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadStockOpnameDetail = true;
			}
		},
		uploadDataStockOpnameDetail(modalEvent, newDatas) {
			this.isShowPopupUploadStockOpnameDetail = false; 
		},
		downloadStockOpnameDetail(modalEvent) {
			this.isDownloadStockOpnameDetail = true;
			this.filterStockOpnameDetail.stockOpnameId = this.modelId;
			StockOpnameDetail.downloadDataDetail(this, this.filterStockOpnameDetail).then(result => {
				this.isDownloadStockOpnameDetail = false;
			}).catch(error => { this.isDownloadStockOpnameDetail = false; })
		},
		saveInputStockOpnameDetail(item) {
			return;
			if (this.stockOpnames != null && this.stockOpnames != undefined  && this.stockOpnames.length > 0) {
				item.stockOpname = this.stockOpnames.find(q => q.id == item.stockOpnameId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.scannedBy = this.userInfos.find(q => q.id == item.scannedByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockOpnameDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadStockOpnameDetail = false; 
			this.isShowPopupStockOpnameDetail = false; 
			if (modalType == 'StockOpnameDetail') {
				this.getStockOpnameDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowStockOpnameDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterStockOpname = new StockOpnameFilter();
		this.filterStockOpnameDetail = new StockOpnameDetailFilter();
		//this.getStockOpnames();
		this.getControlCards();
		this.getParts();
		this.getUserInfos();
		//this.getStockOpnamePlans();
		//this.getAreas();
		//this.getVendors();
		//this.getStockOpnameStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getStockOpname(id);
			} else {
				this.modelId = id;
				this.getStockOpname(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByStockOpnameDetail : {
			handler: function() {
				this.getStockOpnameDetails();
			}
		},
		sortDescStockOpnameDetail: {
			handler: function() {
				this.getStockOpnameDetails();
			}
		},
		currentStockOpnameDetailPage: {
			handler: function() {
				this.getStockOpnameDetails();
			}
		},
		stockOpnameDetailPageSize : {
			handler: function() {
				this.getStockOpnameDetails();
			}
		},
		filterStockOpnameDetail: {
			handler: function() {
				this.getStockOpnameDetails();
			},
			deep: true,
		},
	},
}
</script>
